import { toast } from "react-toastify";

import {
  PostCustomBillingUrlRequestBodyType,
  PostCustomBillingUrlResponseBodyType,
} from "@intelligems/ig-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";
import { organizationsKeys } from "../queryKeys";
import { ApiRequest } from "../types/api";

const getCustomBillingUrl = async (
  data: ApiRequest<PostCustomBillingUrlRequestBodyType>
) => {
  const resp = await api.post<PostCustomBillingUrlResponseBodyType>(
    "/v2/intelligems/custom-billing-url",
    data.body
  );
  return resp.data;
};

export const useGetCustomBillingUrl = (orgId: string) => {
  const queryClient = useQueryClient();
  return useMutation<
    PostCustomBillingUrlResponseBodyType,
    Error,
    ApiRequest<PostCustomBillingUrlRequestBodyType>,
    any
  >({
    mutationFn: async (data: ApiRequest<PostCustomBillingUrlRequestBodyType>) =>
      getCustomBillingUrl(data),
    onSuccess: (data) => {
      queryClient.setQueryData(organizationsKeys.billingUrl(orgId), data);
      toast.success("Billing Link Created!");
    },
  });
};
